import React from 'react';

const RMSOccupancyStatus = ({ currentCount, maxCapacity = 100 }) => {
  const occupancyPercentage = (currentCount / maxCapacity) * 100;

  return (
    <div className=" bg-white pb-6 pl-6 pr-6 pt-5 w-[352px] mx-auto sm:w-[604px] md:w-[780px] lg:w-[800px] xl:w-[380px] 2xl:w-[380px] rounded-xl border border-[#E2E2E4] shadow-[0_1px_2px_0_#dedede]">
      {/* Title and Count */}
      <div className="flex justify-between items-start mb-2">
        <h2 className="text-sm sm:text-sm md:text-md lg:text-lg xl:text-lg 2xl:text-lg font-bold text-gray-800">RMS Occupancy Status</h2>
        <p className="text-2xl sm:text-xl md:text-2xl lg:text-3xl xl:text-3xl 2xl:text-3xl font-extrabold text-blue-800">{currentCount}</p>
      </div>

      {/* Progress Bar */}
      <div className="relative w-full h-4 bg-gray-300 rounded-lg overflow-hidden">
        <div
          className="h-full bg-blue-800"
          style={{
            width: `${occupancyPercentage}%`,
            transition: 'width 0.3s ease',
          }}
        ></div>
      </div>

      {/* Occupancy Percentage Text */}
      <div className='flex justify-between'>
        <p className="text-sm text-gray-600 mt-2">
          {occupancyPercentage.toFixed(0)}% Occupied
        </p>
        <p className="text-xs mt-2.5 text-gray-500">Maximum Capacity: {maxCapacity}</p>
      </div>
    </div>
  );
};

export default RMSOccupancyStatus;
